import { render, staticRenderFns } from "./text-list.vue?vue&type=template&id=194e1486&scoped=true"
import script from "./text-list.vue?vue&type=script&lang=js"
export * from "./text-list.vue?vue&type=script&lang=js"
import style0 from "./text-list.vue?vue&type=style&index=0&id=194e1486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194e1486",
  null
  
)

export default component.exports